import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    localStorage.setItem("nv_token", data.token);
    setUser(data.user);
  };

  const loginDemo = async (driver) => {
    const { data } = await api.post("/auth/demo", { driver });
    localStorage.setItem("nv_token", data.token);
    localStorage.removeItem("nv_pos");
    setUser(data.user);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("nv_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, loginDemo, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
